module.exports = __webpack_public_path__ + "img/route.094cbdab.svg";